import React, { useEffect } from 'react';

import AnalyticsWebClient from '@atlassiansox/analytics-web-client';

import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

interface PreviewPanelBodyProps {
	children: React.ReactNode;
	parentProduct?: string;
	panelType?: string;
	analyticsClient?: AnalyticsWebClient | undefined | null;
	styles?: Record<string, any>;
}

export const PreviewPanelBody = ({
	children,
	analyticsClient,
	parentProduct,
	panelType,
	styles,
}: PreviewPanelBodyProps) => {
	useEffect(() => {
		if (analyticsClient) {
			analyticsClient.sendTrackEvent({
				action: 'viewed',
				actionSubject: 'preview-panel',
				actionSubjectId: 'preview-panel-view',
				source: 'preview-panel',
				attributes: {
					parentProduct,
					panelType,
				},
			});
		}
	}, [analyticsClient, parentProduct, panelType]);

	// ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
	// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
	return <Box xcss={cx(!!styles && styles)}>{children}</Box>;
};
